module.exports = __webpack_public_path__ + "static/media/maga-phone.417a9ad6.png";